import axios from 'axios';
import { getResponseData } from './api.utils';
export const getUserSettings = async () => {
    const endpoint = 'Settings';
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
export const submitUserSettings = async (userSettings) => {
    const endpoint = 'Settings';
    await axios.put(endpoint, userSettings);
};
export const getHolidayYearSummary = async () => {
    const endpoint = 'Settings/GetHolidayYearSummary';
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
export const getFreeDays = async () => {
    const endpoint = 'Settings/FreeDays';
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
